<script setup lang="ts">
import { useIntegrationPartnerDialog } from '../composables/useIntegrationPartnerDialog'
import ArrowRight from '~icons/mdi/arrow-right'

const { isVisible, status, integrationPartner, hideDialog } = useIntegrationPartnerDialog()
const { t } = useI18n()
const dialogStatus = ref(status.value)

const dialogTitle = computed(() =>
  dialogStatus.value === 'success' ? t('dialog.title.success') : t('dialog.title.fail'),
)

const dialogMessage = computed(() => {
  const params = { integrationPartner: integrationPartner?.value }

  if (dialogStatus.value === 'success') {
    return t('dialog.message.success', params)
  }
  return t('dialog.message.fail')
})
</script>

<template>
  <v-dialog
    v-model="isVisible"
    persistent
    max-width="700"
    @click:outside="hideDialog"
  >
    <v-card class="pa-6" rounded="xl">
      <v-card-text class="d-flex" test-id="integration-partner-dialog">
        <img
          src="/images/bird.svg"
          alt="Success Bird"
          class="mr-6"
          width="80"
          height="100"
        >
        <div>
          <h2 class="text-h4 font-weight-bold mb-2 text-red-600">
            {{ dialogTitle }}
          </h2>
          <p class="text-h6 text-vm-grey-8">
            {{ dialogMessage }}
          </p>
        </div>
      </v-card-text>
      <v-card-actions class="pt-0 px-4">
        <v-spacer />
        <v-btn-primary
          block
          color="primary"
          :append-icon="ArrowRight"
          class="font-weight-bold"
          @click="hideDialog"
        >
          {{ t('dialog.exploreButton') }}
        </v-btn-primary>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
